<ng-select
  [items]="members"
  bindLabel="displayName"
  [addTag]="true"
  [multiple]="true"
  [hideSelected]="false"
  [trackByFn]="trackByFn"
  [minTermLength]="2"
  [loading]="membersLoading"
  [typeToSearchText]="typeToSearchText"
  (search)="membersInput$.next($event.term)"
  [(ngModel)]="selectedMembers"
  groupBy="type"
  [placeholder]="placeholder"
  (change)="memberChanged($event)"
  (add)="addMember($event)"
  (remove)="removeMember($event)"
  [placeholder]="placeholder"
  (clear)="removeMember($event)"
  [readonly]="disabled">
  <ng-template
    ng-option-tmp
    let-item="item">
    <div
      class="px-2"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="12px">
      @if (item?.memberType === MassRecipientType.Custom) {
        <div>
          <i class="icon icon-small_close-X" style="font-size: 12px"></i>
        </div>
      }
      <topo-avatar
        [name]="item?.displayName || item?.emailAddress"
      [imageUrl]="item?.profilePhotoUrl"></topo-avatar>
      <div>
        <div fxLayout="row">
          <div class="has-text-weight-semibold">{{ item?.displayName }}</div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template
    ng-label-tmp
    let-item="item">
    <div
      class="px-2"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="12px">
      <topo-avatar
        [name]="item?.displayName || item?.emailAddress"
      [imageUrl]="item?.profilePhotoUrl"></topo-avatar>
      <div>
        <div fxLayout="row">
          <div class="has-text-weight-semibold">{{ item?.displayName }}</div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-select>
